/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import HelpIcon from '@mui/icons-material/Help';
import { Box, Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { fetchExpensesReportDetails } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from 'utils/genericMessages';
import LoadingModal from "components/LoadingModel/loadingModal";
import { useSelector } from "react-redux";
import { formatCurrencyAUD } from 'utils/formatCurrency';
const SCREEN_NAME = "Expense Reports";
let SCREEN_RIGHT;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'grid',
    justifyContent: 'center'
};

createTheme(
    'solarized',
    {
        text: {
            primary: 'white',
            secondary: 'white',
        },
        background: {
            default: '#202940',
        },
        context: {
            background: '#202940',
            text: 'white',
        },
        divider: {
            default: 'white',
        },

        sortFocus: {
            default: '#2aa198',
        },
    },
    'dark',
);
createTheme(
    'light',
    {
        text: {
            primary: 'black',
            secondary: 'black',
        },
        background: {
            default: 'white',
        },
        context: {
            background: 'white',
            text: 'black',
        },
        divider: {
            default: 'gray',
        },
        sortFocus: {
            default: '#2aa198',
        },
    },
    'dark',
);

function ExpensesReport() {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(20);
    const [title, setTitle] = useState("");
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    const { barColor } = getColorMappings(sidenavColor);
    const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
    const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
    const [resetClicked, setResetClicked] = useState(false);
    const [screenAccess, setScreenAccess] = useState(false);
    const [tabledata, setTableData] = useState([]);
    const [values, setValues] = useState({
        _id: [],
        sortingType: "",
        sortingField: "",
        page: appConstants.page,
        limit: appConstants.limit,
        filterValues: "",
        searchParameterList: ['expenseDate', 'supplierName', 'itemCategory', 'taxAmount', 'totalAmount', 'tipAmount'],
        businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?.businessUserID,
        token: token,
        expenseDuration: "last1Year",
        customFrom: new Date(new Date().setDate(new Date().getDate() - 1)),
        customTo: new Date(),
    });

    let currency = useSelector((state) => state.currency.currencySymbol);
    const headers = [
        { label: "Expense Date", key: "expenseDate" },
        { label: "Supplier Name", key: "supplierName" },
        { label: "Category", key: "itemCategory" },
        { label: "Tax Amount", key: "taxAmount" },
        // { label: "Tip Amount", key: "tipAmount" },
        { label: "Total Amount", key: "totalAmount" },
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
                await getRight();
                await fetchExpensesReport();
            } catch (error) {
                console.error("Error in useEffect:", error.message);
            }
        };
        fetchData();
    }, [values.sortingType, perPage]);


    async function getRight() {
        SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
        // setScreenAccess(SCREEN_RIGHT === 'Full Access');
        if (SCREEN_RIGHT === "Full Access") {
            setScreenAccess(true)
        }
        else setScreenAccess(false)
    }

    const ResetData = () => {
        setValues((prevValues) => ({
            ...prevValues,
            searchParameter: "",
            page: appConstants.page,
            limit: appConstants.limit,
            sortingType: "",
            sortingField: "",
            filterValues: "",
            expenseDuration: "",
            searchParameterList: ['expenseDate', 'supplierName', 'itemCategory', 'taxAmount', 'totalAmount', 'tipAmount'],

        }));
        setResetClicked(true);
    };

    const fetchExpensesReport = async () => {
        values.perPage = perPage;
        let toDate = new Date(values.customTo);
        toDate.setUTCHours(0, 0, 0, 0);
        let fromDate = new Date(values.customFrom);
        fromDate.setUTCHours(0, 0, 0, 0);

        if (toDate < fromDate) {
            return showResMsg("To Date should not be less than from date.", 2000, false);
        }
        fetchExpensesReportDetails(values, (data) => {
            setTotalRows(data.result.Result_Output.totalDocs)
            setRows(data.result.Result_Output.docs);
            setTableData(data.result.export);
        }, dispatch)
    };
    function exportSwal() {
        setShowModal(false);
        showResMsg(genericMessage.dataExportedSucces, 1000, true)
    }
    const handleSearchFilter = (event) => {
        setValues({ ...values, filterValues: event.target.value });
    };

    const handleSort = async (type, value) => {
        values.sortingType = value;
        values.sortingField = type;
    };

    const handlePageChange = page => {
        values.page = page;
        fetchExpensesReport();
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);
        values.page = page;
        values.limit = newPerPage
        setPerPage(newPerPage);
        setLoading(false);
    };

    const FilterData = async () => {
        fetchExpensesReport();
    };



    const handleDateChange = (name) => (date) => {
        setValues({ ...values, [name]: new Date(date) });
    };


    let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
    if (changePaginationText !== undefined) {
        changePaginationText.getElementsByTagName('span')[0].textContent = "Records Per Page";
    }

    const handleCustomDateSearch = () => {
        fetchExpensesReport();
    }

    const { tableBorder } = getColorMappings(sidenavColor);
    // useEffect(() => {
    //     const element = document.getElementsByTagName("fieldset");
    //     for (let i = 0; i < element.length; i++) {
    //         if (darkMode) {
    //             element[i].style.borderColor = "white";
    //         } else {
    //             element[i].style.borderColor = tableBorder;
    //         }
    //     }
    // }, [darkMode, tableBorder]);


    useEffect(() => {
        var element = document.getElementsByTagName('fieldset');
        let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
        for (let i = 0; i < element.length; i++) {

            element[i].style.borderColor = darkMode ? "white" : tableBorder;
        }

        for (let i = 0; i < labelShrink.length; i++) {
            labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
        }
    }, [showFilters])

    useEffect(() => {
        var dropicons = document.querySelectorAll('.MuiInputBase-root');
        for (let i = 0; i < dropicons.length; i++) {
            var svgicon = dropicons[i].getElementsByTagName('svg');
            if (svgicon.length > 0) {
                if (darkMode) {
                    svgicon[0].setAttribute("style", "fill: white !important;");
                } else {
                    svgicon[0].setAttribute("style", "");
                }
            }
        }

    }, [showFilters])

    let columns = [
        {
            // name: "Expense Date",
            name: <p style={{ fontSize: "12px" }}>Expense Date</p>,
            selector: row => row.expenseDate,
            sortable: true,
            sortField: 'expenseDate',
        },
        {
            // name: "Supplier Name",
            name: <p style={{ fontSize: "12px" }}>Supplier Name</p>,
            selector: row => row.supplierName,
            sortable: true,
            sortField: 'supplierName',
            center: true,

        },
        {
            // name: "Category",In
            name: <p style={{ fontSize: "12px" }}>Account</p>,
            selector: row => row.itemCategory,
            sortable: true,
            sortField: 'itemCategory',
        },
        {
            // name: "Tax Amount",
            name: <p style={{ fontSize: "12px" }}>{`Tax Amount (${currency})`}</p>,
            selector: row => formatCurrencyAUD(row.taxAmount),
            sortable: true,
            sortField: 'taxAmount',
            center: true,
        },
        // {
        //     // name: "Tip Amount",
        //     name: <p style={{ fontSize: "12px" }}>Tip Amount</p>,
        //     selector: row => row.tipAmount,
        //     sortable: true,
        //     sortField: 'tipAmount',
        //     center: true,
        // },
        {
            // name: "Total Amount",
            name: <p style={{ fontSize: "12px" }}>{`Total Amount (${currency})`}</p>,
            selector: row => formatCurrencyAUD(row.totalAmount),
            sortable: true,
            sortField: 'totalAmount',
            center: true,
        }
    ];

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ marginTop: '20px' }}>
                <Card color="primary">
                    <PageTitle screenName="Expenses Report" />
                    <Grid container columnSpacing={2} px={2} mt={1} alignItems="center" display="flex" justifyContent="right">

                        <Grid item xs={12} md={4} spacing={2} lg={1.4}  >

                            <MDButton
                                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                color={"warning"}
                                fullWidth
                                onClick={() => { setShowFilters(!showFilters) }}
                                style={{ height: "38.11px" }}
                            >
                                {showFilters ? 'Hide Filters' : 'Set Filters'}

                            </MDButton>
                        </Grid>

                        <Grid item xs={12} md={4} spacing={2} lg={1.4} >

                            {screenAccess ?
                                <MDButton
                                    className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                    // color={disableColor ? "secondary" : "success"}
                                    // fullWidth
                                    // onClick={disableColor ? blank : () => { setShowModel(true) }}
                                    // color={"primary"}
                                    style={{ backgroundColor: "#009cff", color: "#ffffff", height: "38.11px" }}
                                    fullWidth
                                    onClick={() => { setShowModal(true) }}

                                >
                                    Export
                                </MDButton>
                                :
                                <MDButton
                                    className
                                    ={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                    style={{ height: "38.11px" }}
                                    color={"secondary"}
                                    fullWidth

                                >
                                    Export

                                </MDButton>
                            }
                        </Grid>
                    </Grid>
                    {showFilters && (
                        <MDBox>
                            <Grid item xs={12} >
                                <MDBox px={1} pt={1}>
                                    <Grid container columnSpacing={2} px={4} justifyContent="end">
                                        {values.expenseDuration === "Custom" && (
                                            <Grid lg={3} container spacing={2} sx={{ display: 'flex', justifyContent: 'start', paddingLeft: '10px' }}>
                                                <Grid item xs={6} lg={6} >
                                                    <PickDate
                                                        selected={new Date(values.customFrom)}
                                                        onChange={handleDateChange('customFrom')}
                                                        label="From"
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} lg={6}>
                                                    <PickDate
                                                        selected={new Date(values.customTo)}
                                                        onChange={handleDateChange('customTo')}
                                                        label="To"
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        maxDate={new Date()}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} lg={3}>
                                            <MDBox mb={4} xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="expenseDate">Expense Duration</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        // style={{ minHeight: "3em" }}
                                                        label="Expense Duration"
                                                        style={{ height: "38.11px" }}
                                                        value={values.expenseDuration}
                                                        onChange={(e) => setValues({ ...values, expenseDuration: e.target.value })}
                                                    >
                                                        <MenuItem value="Today"> Today </MenuItem>
                                                        <MenuItem value="last7Days"> Last 7 Days  </MenuItem>
                                                        <MenuItem value="last30Days"> Last 30 Days </MenuItem>
                                                        <MenuItem value="last1Year"> Last 12 Month </MenuItem>
                                                        <MenuItem value="Custom"> Custom Date</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={3}>
                                            <TextField
                                                type="text"
                                                variant="outlined"
                                                fullWidth
                                                className="searchButton"
                                                placeholder="Search..."
                                                label="Search Filter"
                                                value={values.filterValues}
                                                onChange={handleSearchFilter}
                                                onKeyUp={(e) => {
                                                    if (e.key === "Enter") fetchExpensesReport();
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment  >
                                                            <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchExpensesReport}>
                                                                <GridSearchIcon color="white" />
                                                            </Button>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                                            <Link to={"/ExpensesReport"}>
                                                <MDButton
                                                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                    color="warning"
                                                    fullWidth
                                                    onClick={ResetData}
                                                    style={{ height: "38.11px" }}
                                                >
                                                    Reset
                                                </MDButton>
                                            </Link>
                                        </Grid>

                                        <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                                            <MDButton
                                                rel="noreferrer"
                                                variant="gradient"
                                                color="success"
                                                fullWidth
                                                onClick={FilterData}
                                                style={{ height: "38.11px" }}
                                            >
                                                Apply
                                            </MDButton>
                                        </Grid>

                                    </Grid>
                                </MDBox>
                            </Grid>
                        </MDBox>
                    )}

                    {/* <CardContent> */}
                    <BTable
                        title={title}
                        columns={columns}
                        data={rows}
                        sortingType={handleSort}
                        sortServer
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        fixedHeaderScrollHeight="410px"
                        fixedHeader={true}
                    />
                    {/* </CardContent> */}
                </Card>
                {showModal &&
                    <Modal
                        open={showModal}
                        onClose={() => setShowModal(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Card sx={style}>
                            <Box>
                                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
                                    <HelpIcon style={{ color: "red" }} />
                                </Typography>
                                <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
                                    Would you like to export this record?
                                </Typography>
                                <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                                    <>
                                        <MDButton className="no-button" onClick={() => { setShowModal(false) }} sx={{ width: "64px", textTransform: "capitalize" }}>
                                            No
                                        </MDButton>
                                    </>
                                    &nbsp; &nbsp;
                                    <>
                                        <CSVLink data={tabledata} headers={headers} filename={"Expenses Report (" + (new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })) + ") .csv"}>
                                            <MDButton className="yes-button" onClick={() => { exportSwal() }} sx={{ width: "64px", textTransform: "capitalize" }}>
                                                Yes
                                            </MDButton>

                                        </CSVLink>
                                    </>
                                </Grid>
                            </Box>
                        </Card>
                    </Modal>
                }
                <LoadingModal loading={loading} />
            </div>
        </DashboardLayout>
    );
}

export default ExpensesReport;
